module.exports = __webpack_public_path__ + "img/yoyolumi.7c6df99f.png";